import React from 'react'
import { Col } from 'reactstrap'

export const ColStyle = ({ children }) => (
  <Col className="pl-sm-0" sm="12" md="12" lg="10" xl="8">
    {children}
  </Col>
)

export const ColStyleLeft = ({ children }) => (
  <Col className="pl-sm-0" sm="8" md="8" lg="6" xl="5">
    {children}
  </Col>
)

export const ColStyleRight = ({ children }) => (
  <Col className="pl-sm-0" sm="4" md="4" lg="4" xl="3">
    {children}
  </Col>
)
